import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IDropdownModel } from "@models";

// One dropdown on the Auto Cover spec sheet. Desktop gets the usual slick-drop-down. A phone gets a
// field that opens its options as a list of big tap targets instead, because slick-drop-down is a
// typeahead: tapping it focuses a text box, the keyboard comes up and pushes the wizard's Back/Next
// bar up over the list, and a long list (Model, Leading Edge Size) ends up under the keyboard where
// nothing can be picked.
@Component({
	selector: "auto-cover-select",
	templateUrl: "./auto-cover-select.component.html",
	styleUrls: ["./auto-cover-select.component.scss"]
})
export class AutoCoverSelectComponent {
	@Input() items: IDropdownModel[] = [];
	@Input() value: string;
	@Input() isMobile: boolean = false;
	@Input() disabled: boolean = false;
	// Heads the option list on a phone
	@Input() label: string;
	@Input() placeholder: string = "-- Select --";
	@Output() valueChange = new EventEmitter<string>();

	showOptions: boolean = false;

	// A recorded value that's no longer offered (an option renamed since) still shows as recorded
	get selectedText(): string {
		if (this.value === null || this.value === undefined || this.value === "")
			return "";

		return this.items?.find(x => x.id === this.value)?.text ?? this.value;
	}

	open() {
		if (this.disabled)
			return;

		// iOS doesn't move focus to a tapped button, so a box typed into just before (a date, a
		// measurement) stays focused and keeps the keyboard up under the list. Let go of it.
		(document.activeElement as HTMLElement)?.blur?.();
		this.showOptions = true;
	}

	close() {
		this.showOptions = false;
	}

	pick(item: IDropdownModel) {
		this.close();
		this.setValue(item?.id ?? null);
	}

	// slick-drop-down reports its value on every write, including the one that loads it, so only a real
	// change is passed on
	setValue(value: string) {
		const newValue = (value === undefined || value === "") ? null : value;
		if (newValue === (this.value ?? null))
			return;

		this.value = newValue;
		this.valueChange.emit(newValue);
	}
}
